import { useEffect, useState } from "react";
import {
  contactPreferredEmail,
  formatContactDisplayName,
  type Contact,
  type ContactEmailOption,
} from "@domaddress/shared";

type Props = {
  contact: Contact;
  options: ContactEmailOption[];
  onConfirm: (email: string) => void;
  onCancel: () => void;
};

/**
 * Laat de gebruiker kiezen welk e-mailadres in de zend-lijst / het Aan-veld komt
 * wanneer een contact meerdere adressen heeft.
 */
export default function PickContactEmailModal({ contact, options, onConfirm, onCancel }: Props) {
  const defaultEmail =
    contactPreferredEmail(contact) ?? options[0]?.email ?? "";
  const [selected, setSelected] = useState(defaultEmail);

  useEffect(() => {
    setSelected(contactPreferredEmail(contact) ?? options[0]?.email ?? "");
  }, [contact, options]);

  return (
    <div
      className="modal-overlay"
      onClick={onCancel}
      role="dialog"
      aria-modal="true"
      aria-labelledby="pick-email-modal-title"
    >
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 440 }}>
        <div className="modal-header">
          <h2 id="pick-email-modal-title">Welk e-mailadres?</h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Sluiten">
            ✕
          </button>
        </div>
        <div className="modal-body">
          <p className="page-subtitle" style={{ marginTop: 0 }}>
            Kies het adres voor <strong>{formatContactDisplayName(contact)}</strong> in de zend-lijst en het
            Aan-veld.
          </p>
          <fieldset style={{ border: "none", padding: 0, margin: "0 0 1rem" }}>
            <legend style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0,0,0,0)" }}>
              E-mailadres
            </legend>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {options.map((opt) => (
                <li key={opt.key} style={{ marginBottom: "0.65rem" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 10,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="zend-contact-email"
                      value={opt.email}
                      checked={selected === opt.email}
                      onChange={() => setSelected(opt.email)}
                      style={{ marginTop: 4 }}
                    />
                    <span>
                      <span style={{ display: "block", fontWeight: 600 }}>{opt.label}</span>
                      <span style={{ display: "block", color: "var(--text-muted, #666)" }}>{opt.email}</span>
                    </span>
                  </label>
                </li>
              ))}
            </ul>
          </fieldset>
          <p style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: 0 }}>
            <button type="button" className="btn-primary" onClick={() => onConfirm(selected)}>
              Toevoegen
            </button>
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Annuleren
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
